import React, { useState, useEffect } from 'react'
import i18n from 'live/services/i18n'
import WebSettingsCard from 'live/components/ui/admin/web-settings-card'
import ActionToggle from 'live/components/ui/action-toggle'
import globalNotification from 'live/services/global-notification'
const RESOURCE_URL = '/services/plugin-asset-aggregator/configuration/aggregator'

const Configuration = (): JSX.Element => {
    const [editMode, setEditMode] = useState(false)
    const [saved, setSaved] = useState(false)
    const [loading, setLoading] = useState(true)
    const [configPayload, setConfigPayload] = useState({ aggregationRestartOnAllAssetSaveDisabled: false
                                                        })

    useEffect(() => {
        fetch(RESOURCE_URL)
            .then(resp => {
                return resp.json()
            })
            .then(data => {
                setConfigPayload(data)
            })
            .catch(error => {
                globalNotification.failed(i18n('Failed to get the path', error))
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    const onSave = (): void => {
        const headers = {
            'content-type': 'application/json'
        }

        const body = {
            ...configPayload
        }

        setLoading(true)

        fetch(RESOURCE_URL, { method: 'POST', body: JSON.stringify(body), headers })
            .then(resp => {
                if (resp.status !== 200) return Promise.reject(resp)
                setEditMode(false)
                setSaved(true)
                globalNotification.success(i18n('Settings successfully saved'))
            })
            .catch(error => {
                error.json().then(payload => {
                    globalNotification.error(i18n('Failed to save settings') + ': ' + i18n(payload.message))
                })
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <WebSettingsCard
            name="aggregator-base-config"
            className="live-feature"
            open={editMode}
            error={''}
            saved={saved}
            save={onSave}
            hideButton={loading}
            savedMessage={i18n('Aggregator Configuration settings successfully saved')}
            toggle={(name, status) => {
                setEditMode(status === 'open')
                setSaved(status !== 'open')
            }}
        >
            <h2>{i18n('Base Configuration')}</h2>
            {loading ? <span>{i18n('Loading from server...')}</span> : (
                <>
                    <div className="form-group">
                        <label>{i18n('Disable Restart Aggregation after every Asset Save')}</label>
                        <div className="flex">
                            <div className="flex-1">
                                <ActionToggle
                                    onChange={() => {
                                            setConfigPayload({ ...configPayload, aggregationRestartOnAllAssetSaveDisabled: !configPayload.aggregationRestartOnAllAssetSaveDisabled })
                                            setSaved(false);
                                        }
                                    }
                                    elLeft={<span>on</span>}
                                    elRight={<span>off</span>}
                                    active={configPayload.aggregationRestartOnAllAssetSaveDisabled}
                                    disabled={!editMode}
                                />
                            </div>
                            <div className="flex-1">
                                <div className="flex">
                                    <span className="help-block">
                                        <i className="fa fa-info-circle" />
                                    </span>
                                    <span className="help-block">
                                        <span>
                                            {i18n(
                                                'If disabled will let the aggregations decide if they should be restarted/reregistered. If enabled it will only restart aggregations for specific changes in the normalization.'
                                            )}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </WebSettingsCard>
    )
}

export default {
    name: i18n('Configuration'),
    key: 'aggregator-base-config',
    section: i18n('Asset Aggregator Settings'),
    configComponent: Configuration
}
